<template>
    <el-dialog
        class="preview-article-dialog"
        :visible.sync="visible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        fullscreen
    >
        <div class="preview">
            <div class="preview-title">{{ title }}</div>
            <div class="preview-content">
                <div class="introduction">
                    {{ introduction }}
                </div>
                <div class="content" v-if="videoUrlList && videoUrlList.length > 0">
                    <video v-for="video in videoUrlList" :src="video" :key="video" controls controlsList="nodownload"></video>
                </div>
                <div class="content" v-if="pictureList && pictureList.length > 0">
                    <img v-for="picture in pictureList" :src="picture" :key="picture" />
                </div>
                <div class="introduction" v-if="content" v-html="content"></div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit">立即发布</el-button>
            <el-button @click="handleClose">返回上级</el-button>
        </span>
    </el-dialog>
</template>

<script>
import AliOSS from 'ali-oss';
import { getOSSConfig } from '@/api/common';

export default {
    name: 'PreviewArticle',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        introduction: {
            type: String,
            default: ''
        },
        videoList: {
            type: Array,
            default: () => []
        },
        pictureList: {
            type: Array,
            default: () => []
        },
        content: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        videoUrlList: [],
    }),
    mounted() {
        this.getBuffer();
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        },
        handleSubmit() {
            this.$emit('handleSubmit');
            this.$emit('update:visible', false);
        },
        async getBuffer () {
            let config = await getOSSConfig();
            var client = new AliOSS({
                    region: 'oss-cn-chengdu',
                    accessKeyId: config.data.accessid,
                    accessKeySecret: 'fEenefEpkSzxjT3wsIidFDHRHdslq9',
                    bucket: 'shuzixs1',
                    policy: config.data.policy,
                    signature: config.data.signature,
                    secure: true
                });
            for (let i = 0; i < this.videoList.length; i++) {
                let video = await client.signatureUrl(this.videoList[i]);

                this.$set(this.videoUrlList, i, video);
            }
        }
    }
};
</script>

<style lang="scss">
.preview-article-dialog {
    .el-dialog__body {
        padding: 20px;
        color: #000;
        font-size: 16px;
    }
    .el-dialog__footer {
        text-align: center;
    }
}
</style>

<style lang="scss" scoped>
.preview-article-dialog {
    .preview {
        margin: 0 auto;
        width: 1280px;
        height: calc(100vh - 160px);
        overflow-x: hidden;
        overflow-y: auto;
        &-title {
            color: #272c40;
            font-size: 22px;
            font-weight: 600;
            padding-bottom: 10px;
            border-bottom: 1px solid #ecedff;
        }
        &-content {
            padding: 20px 10px;
            overflow: auto;

            .introduction {
                max-width: 850px;
                margin: 0 auto 20px;
                line-height: 24px;
                @include font(#272c40, 16px, 400);
            }

            img, video {
                display: block;
                margin: 0 auto 10px;
                max-width: 850px;
                box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
            }
            video {
                margin-bottom: 30px;
            }
        }
    }
}
</style>
